export default "__VITE_ASSET__DzsTHIYO__"